<template>
  <b-button
    :title="title"
    :style="{ '--color': color }"
    class="matrix-association-button has-text-weight-bold"
    :class="{ active: association && !disabled, [`${row.code}-${column.code}`]: true }"
    :disabled="disabled"
    :loading="toggling"
    @click="toggle_"
  >
    {{ association ? "ON" : "OFF" }}
  </b-button>
</template>

<script>
export default {
  props: {
    association: {
      type: Boolean,
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    column: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      default: () => {}
    },
    toggle: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    toggling: false
  }),
  computed: {
    title() {
      return `
        X-Axis - TYPE: ${this.column.type}, CODE: ${this.column.code}, NAME: ${
        this.column.name
      }, GROUP: ${this.column.group || "N/A"} |
        Y-Axis - TYPE: ${this.row.type}, CODE: ${this.row.code}, NAME: ${
        this.row.name
      } | GROUP: ${this.row.group || "N/A"}
      `;
    },
    color() {
      // Force random color instead of using attributes
      return this.colors[this.row.group];

      // const attribute = this.row.attributes.find(
      //   attribute => attribute.code === "code_type_color"
      // );
      // return attribute ? attribute.value : this.row.typeColor;
    },
    disabled() {
      return !this.row.status || !this.column.status;
    }
  },
  methods: {
    async toggle_() {
      this.toggling = true;

      try {
        await this.toggle();

        this.$buefy.toast.open({
          message: "Codes has been associated.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.toggling = false;
    }
  }
};
</script>

<style scoped>
.matrix-association-button.active,
.matrix-association-button:hover {
  background-color: var(--color);
  border-color: var(--color);
}
.matrix-association-button[disabled]:hover {
  border-color: inherit;
  background-color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/CodesMatrixManager/partials/matrixAssociation.vue